import axios from "../../../../utils/request";

function GET_NAME(params) {
  return axios.get("/translation/BatchTranslation/customerList", {
    params: params
  });
}
export default {
  GET_NAME
};
